"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayerDice = exports.getDiceById = exports.DICE_LIST = void 0;
const career_1 = require("./career");
const DICE_LIST = [
    { id: "default", color: "#000000", background: "#ffffff", price: 0 },
    {
        id: "s17-blood-debug",
        color: "#ffffff",
        background: "#cc0000",
        price: 30,
        season: 17,
        rarity: career_1.AVATAR_RARITY.COMMUN,
    },
    {
        id: "s19-blood",
        color: "#ffffff",
        background: "#cc0000",
        price: 30,
        season: 19,
        rarity: career_1.AVATAR_RARITY.SEASONAL,
    },
    {
        // Or sur pourpre profond. Contraste WCAG 9.4:1, contre 5.9:1 pour le
        // blanc sur rouge des saisons 17 et 19 : les points restent lisibles même
        // au format réduit du journal de match.
        id: "s20-gold",
        color: "#f5c542",
        background: "#2d1b4e",
        price: 30,
        season: 20,
        rarity: career_1.AVATAR_RARITY.SEASONAL,
    },
];
exports.DICE_LIST = DICE_LIST;
const getDiceById = (id) => {
    if (!id)
        return DICE_LIST[0];
    return DICE_LIST.find((d) => d.id === id) ?? DICE_LIST[0];
};
exports.getDiceById = getDiceById;
// kept for backwards compatibility
const getPlayerDice = () => DICE_LIST[0];
exports.getPlayerDice = getPlayerDice;
// TODO: when RARE or UNIQUE dice are added, add access conditions:
// - StoreDice.tsx: filter dice based on player eligibility before displaying
// - BuyService.js: enforce the same check server-side before allowing purchase
